import { User as FirebaseUser } from "firebase/auth";

export class User {
  uid: string;
  email: string;
  name: string;
  displayName: string;
  acceptedCookies: boolean;
  rejectedCookies: boolean;
  partnerId: string;
  isAssignmentAdmin: boolean;
  behavior: {
    [key: string]: any;
  };
  playlists: {
    [key: string]: any;
  };
  partnerData: {
    isPartnerUser: boolean;
    partnerId: string;
    partnerSlug: string;
  };
  partnerSlug: string;

  constructor(
    user: User &
      FirebaseUser & {
        acceptedCookies?: boolean;
        rejectedCookies?: boolean;
        partnerId?: string;
        isAssignmentAdmin?: boolean;
        behavior?: {
          [key: string]: boolean;
        };
        playlists?: {
          [key: string]: any;
        };
        partnerData?: {
          isPartnerUser: boolean;
          partnerId: string;
          partnerSlug: string;
        };
      },
  ) {
    this.uid = user.uid;
    this.email = user.email || "";
    this.name = user.name || "";
    this.displayName = user.displayName || "";
    this.acceptedCookies = user.acceptedCookies || false;
    this.rejectedCookies = user.rejectedCookies || false;
    this.partnerId = user.partnerId || "";
    this.isAssignmentAdmin = user.isAssignmentAdmin || false;
    this.behavior = user.behavior || {};
    this.playlists = user.playlists || {};
    this.partnerData = user.partnerData || {
      isPartnerUser: false,
      partnerId: "",
      partnerSlug: "",
    };
    this.partnerSlug = user.partnerSlug || "";
  }

  get id() {
    return this.uid;
  }
}
